import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Box, Typography, CircularProgress, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
export default function Activity() {
  const [data, setData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);
  const accessToken = sessionStorage.getItem("accessToken");
  const fetchInfo = () => {
    axios
      .get(`${apiUrl}/activity`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      })
      .then((response) => {
        const sortedData = response.data.sort(
          (b, a) => new Date(a.timestamp) - new Date(b.timestamp)
        );
        setData(sortedData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  let isAdmin = useSelector((state) => state.admin.value);
  let isMember = useSelector((state) => state.member.value);

  const columns = [
    {
      field: "username",
      headerName: "User",
      flex: 1,
      headerClassName: "bg-customBlue text-white ",
    },
    {
      field: "action",
      headerName: "Action",
      flex: 2,
      headerClassName: "bg-customBlue text-white",
    },
    // {
    //   field: "resourceType",
    //   headerName: "Resource",
    //   flex: 0.5,
    //   sortable: false,
    //   headerClassName: "bg-customBlue text-white",
    // },
    {
      field: "accounts",
      headerName: "Accounts",
      sortable: false,
      flex: 1.5,
      headerClassName: "bg-customBlue text-white",
    },
    {
      field: "timestamp",
      headerName: "Time",
      headerClassName: "bg-customBlue text-white rounded-tr-xl",
      flex: 0.8,
    },
  ];
  const rows = [...data];
  const paginationModel = { page: 0, pageSize: 10 };

  return (
    <Box
      sx={{
        marginLeft: "180px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 2,
        pt: 5,
        backgroundColor: "#EEEEEE",
        minHeight: "100vh",
      }}
    >
      {isAdmin || isMember ? (
        <>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ color: "#00ADB5", fontFamily: "Poppins", fontWeight: "bold" }}
          >
            Activity Logs
          </Typography>
          <Paper
            sx={{
              height: 629,
              width: "100%",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            }}
          >
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                <CircularProgress color="primary" />
              </Box>
            ) : (
              <>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  initialState={{ pagination: { paginationModel } }}
                  pageSizeOptions={[10, 20, 30]}
                  sx={{
                    border: 0,
                    fontFamily: "Poppins",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    "&.MuiDataGrid-root": {
                      outline: "none",
                    },
                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within":
                      {
                        outline: "none",
                      },
                  }}
                />
              </>
            )}
          </Paper>
        </>
      ) : (
        <Box sx={{ textAlign: "center", mt: 10 }}>
          <Typography
            variant="h5"
            sx={{ color: "red", fontWeight: "bold", fontFamily: "Poppins" }}
          >
            You are not authorized to view this page. Ask Admin to provide
            access.
          </Typography>
        </Box>
      )}
    </Box>
  );
}
